import React from 'react';
import { AppBar, Toolbar, Typography, Container, Box, useTheme } from '@mui/material';

function Header() {
  const theme = useTheme();

  return (
    <AppBar 
      position="static" 
      sx={{ 
        backgroundColor: 'white',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
        borderBottom: `1px solid ${theme.palette.grey[200]}`
      }}
    >
      <Container maxWidth="lg">
        <Toolbar sx={{ py: 1.5, justifyContent: 'center' }}>
          <Box 
            sx={{ 
              display: 'flex', 
              alignItems: 'center', 
              gap: 2,
              '& img': {
                transition: 'transform 0.2s ease-in-out',
                '&:hover': {
                  transform: 'scale(1.05)'
                }
              }
            }}
          >
            <img 
              src="/assets/image/logo.png" 
              alt="William Lecuyer Electricien Logo" 
              style={{ 
                height: '65px', 
                width: 'auto',
                objectFit: 'contain'
              }}
            />
            <Typography 
              variant="h4" 
              component="div"
              sx={{ 
                color: theme.palette.primary.main,
                fontWeight: 600,
                letterSpacing: '0.5px',
                '@media (max-width: 600px)': {
                  fontSize: '1.3rem'
                }
              }}
            >
              William Lecuyer Electricien
            </Typography>
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
}

export default Header; 